import axios from "axios";
import { antUtils } from "@/utils/globalAnt"
import { message } from "antd";
import { isDev } from "@/config/common";

const request = axios.create();

request.defaults.responseType = 'json';

request.interceptors.response.use(
  res => {
    const uri = new URL(res.request.responseURL);
    if (res.status === 204) {
      return res.data
    }
    if(!res.data){
      return Promise.reject('请求错误');
    }
    if (/^\/workbenchApi\//.test(uri.pathname) && !/^\/workbenchApi\/api\/v3/.test(uri.pathname)) {
      if (res.data.code !== 0) {
        const msg = res.data.msg || '未知错误';
        return Promise.reject(msg);
      }
      return res.data.data;
    }
    if (/^\/workbenchApi\/api\/v3/.test(uri.pathname)) {
      if (res.data && res.data._type && /^error$/i.test(res.data._type)) {
        return Promise.reject(res.data.message);
      }
    }
    return res.data;
  },
  error => {
    if (error.response.status === 401) {
      if (isDev){
        if (window.location.pathname === '/auth/jwt' || window.location.pathname === '/auth/email') {
          return Promise.reject(error);
        }
        const redirect = window.location.pathname + window.location.search;
        window.location.href = `/auth/email?redirect_uri=${encodeURIComponent(redirect)}`;
      }else {

          if (window.location.pathname === '/workbenchApi/auth/sso-login') {
            return Promise.reject(error);
          }
          const url = new URL('/workbenchApi/auth/sso-login', window.location.origin);
          url.searchParams.append('redirect_uri', window.location.href);
          window.location.href = url.href;
      }
    } 
    const data = error.response.data;
    const text = data?.message || data?.msg || error.message || error.response.statusText;
    
    return Promise.reject(text); 
  }
);

export default request;
